export default __webpack_public_path__ + "static/classic-8797e10526da9194dd52c9b85b32f912.png";